<template>
  <v-card
    rounded="sm"
    outlined
    class="proposal-card-responsive secondary--text"
    :style="style"
    v-intersect.once="handleView"
    style="box-shadow: 5px 6px 6px #0000001A;
border: 1px solid #BFBFBF;
border-radius: 6px;
opacity: 1;"
  >
    <v-row no-gutters>
      <v-col cols="12" sm="12" lg="12" xl="12">
        <v-img
          :src="src"
          :alt="proposal.imgAlt"
          :title="proposal.imgDescription"
          cover
        />
      </v-col>
      <v-col cols="12" sm="12" lg="12" xl="12" class="d-flex flex-column">
        <v-card-title v-if="proposal.descr"
          ><v-icon class="d-flex justify-start pa-3" style="font-size: 45px;"
            >${{ proposal.metaData.icon }}</v-icon
          >
          <h3>{{ proposal.descr }}</h3></v-card-title
        >
        <v-card-text v-if="proposal.content" v-html="proposal.content">
        </v-card-text>
        <v-spacer />
        <v-card-actions
          class="mt-10 pa-5"
          v-if="link && $ebsn.meta(proposal, 'category_proposal_type.SHOW_BTN')"
        >
          <v-btn
            :href="link"
            @click.prevent="handleLink"
            color="primary secondary--text"
            block
            depressed
            height="48px"
          >
            {{
              $ebsn.meta(
                proposal,
                "category_proposal_type.BTN_TEXT",
                "SCOPRI LE OFFERTE"
              )
            }}
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>
</template>
<style lang="scss">
.proposal-card-responsive {
  .v-card__title {
    padding: 8px;
    h3 {
      font-size: 20px;
    }
  }
  p {
    font-size: 14px;
    margin-bottom: 0;
  }
  .v-btn__content {
    font-size: 12px !important;
  }
}
</style>
<script>
import get from "lodash/get";
import banner from "~/mixins/banner";
import Vue from "vue";
export default {
  name: "ProposalCardResponsiveNew",
  props: {
    proposal: { type: Object, required: true }
  },
  mixins: [banner],
  computed: {
    style() {
      let style = {};
      let backgroundColor = Vue.$ebsn.meta(
        this.config,
        "category_proposal_type.COLOR"
      );
      if (backgroundColor) {
        style.backgroundColor = backgroundColor;
      }
      //  else {
      //   style.backgroundColor = "var(--v-primary-lighten2)";
      // }
      return style;
    },
    src() {
      let isXs = this.$vuetify.breakpoint.xsOnly;
      let prop =
        "metaData.category_proposal_type." +
        (isXs ? "IMAGE_MOBILE" : "IMAGE_DESKTOP");
      return get(this.proposal, prop, this.proposal.img);
    }
  }
};
</script>
